import React, { useEffect, useState } from "react";
import {
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { toast } from "react-toastify";

import { API } from "../../../backend";
import SpinnerComponent from "../../../components/Loder/spinner";

const PaymentExistintEle = ({
  amount,
  paymentintentid,
  clientSecret,
  inoviceid,
  customer_id,
  value,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const currentUrl = window.location.origin;

  useEffect(() => {
    if (!stripe) {
      return;
    }

    if (!clientSecret) {
      return;
    }
    stripe.retrievePaymentIntent(clientSecret).then(({ paymentintentid }) => {
      switch (paymentintentid.status) {
        case "succeeded":
          setMessage("Payment succeeded!");
          break;
        case "processing":
          setMessage("Your payment is processing.");
          break;
        case "requires_payment_method":
          setMessage("Your payment was not successful, please try again.");
          break;
        default:
          setMessage("Please log a support ticket or send email to support@athenafintech.com.");
          break;
      }
    })
  }, [stripe]);

  useEffect(() => {
    handlepaymentintentupdate(); // Call handlepaymentintentupdate with the IP address
  }, [amount, inoviceid, customer_id]);
  
  const handlepaymentintentupdate = async () => {
    try {
      const body = {
        paymentintent_id: paymentintentid,
        amount: amount,
        inoviceid: inoviceid,
        customer_id: customer_id,
      };
      // if (amount > 100) {
        const response = await fetch(
          API + "accounting/update-payment-stripeaccount/",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
          }
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();
      // }
      // }
    } catch (error) {
      console.error("Error fetching client secret:", error);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (customer_id !== "") {
      if (!stripe || !elements) {
        return;
      }
      setLoading(true);


      const { error } = await stripe.confirmPayment({
        elements,

        confirmParams: {
          // return_url: "https://test.athenafintech.com/paymentconfirmsuccess?",
          return_url: currentUrl + "/paymentconfirmsuccess?",
        },
      });

      if (error.type === "card_error" || error.type === "validation_error") {
        setMessage(error.message);
        setLoading(false);
        
      } else {
        setMessage("An unexpected error occurred.");
        setLoading(false);
      }
    } else {
      toast.error("Customer is required");
      setLoading(false);
    }
  };

  const paymentElementOptions = {
    layout: "tabs",
  };

  return (
    <>
    {loading && <SpinnerComponent />}
    <form id="payment-form" onSubmit={handleSubmit}>
      <PaymentElement id="payment-element" options={paymentElementOptions} />
      <div style={{ marginTop: "1rem" }}>
        {/* <button className="btn btn-danger mt-3" 
        style={{ marginRight: '10px' }}>
          Cancel
        </button> */}
        <button
          className="btn btn-primary mt-3 "
          disabled={!stripe || !elements}
          id="submit"
          >
          <span id="button-text">Pay</span>
        </button>
      </div>
      {message && <div id="payment-message">{message}</div>}
    </form>
          </>
  );
};

export default PaymentExistintEle;
